import React from "react";
import loadable from "@loadable/component";
import PageLoader from "../../../components/shared/page-loader";
const CarListing = loadable(() => import("../../../components/au.desktop/car-listing"), {
    fallback: <PageLoader />
});
import withAULayout from "../../../components/au.desktop/layout";

const CarListingPage = () => <CarListing />;

export default withAULayout(CarListingPage, true, true, {headerProps: {fixed: true}});
